import * as React from "react"
import {useTranslation} from "react-i18next";
import NavBar from "../components/NavBar";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import {handleSetQuery} from "../assets/js/main";
import {Add} from "@mui/icons-material";


export default function Rules() {
  const {t} = useTranslation()
  const location = useLocation();

  const rulesItem = [
     {
      label: 'rules.s1.t1',
      items: [
        'rules.s1.t2',
        'rules.s1.t3',
        'rules.s1.t4',
        'rules.s1.t5',
        'rules.s1.t6',
        'rules.s1.t7',
        'rules.s1.t8',
        'rules.s1.t9',
        'rules.s1.t10',
        'rules.s1.t11',
        'rules.s1.t12',
        'rules.s1.t13',
        'rules.s1.t14',
        'rules.s1.t15',
        'rules.s1.t16',
        'rules.s1.t17',
        'rules.s1.t18',
        'rules.s1.t19',
        'rules.s1.t20',
      ]
    },
    {
      label: 'rules.s2.t1',
      items: [
        'rules.s2.t2',
        'rules.s2.t3',
        'rules.s2.t4',
        'rules.s2.t5',
        'rules.s2.t6',
        'rules.s2.t7',
        'rules.s2.t8',
      ]
    },
    {
      label: 'rules.s3.t1',
      items: [
        'rules.s3.t2',
        'rules.s3.t3',
        'rules.s3.t4',
        'rules.s3.t5',
        'rules.s3.t6',
      ]
    },
  ]

  return (
     <>
       <NavBar/>

       <div className="rulesPage desktopSection">
         <div className="container">
           <div className="row">
             <div className="col-12">

               <h2>{t("rules.t1")}</h2>
               <p>{t("rules.t2")}</p>

               <div className="items">
                 {
                   rulesItem?.map((item, index) => {
                     return (
                        <div className="item" key={index}>
                          <h4>{t(item?.label)}</h4>
                          <ul>
                            {
                              item?.items?.map((item2, index2) => {
                                return (
                                   <li key={index2}>{t(item2)}</li>
                                )
                              })
                            }
                          </ul>

                        </div>
                     )
                   })
                 }
               </div>
             </div>

             <div className="col-12">
               <div className="_btnGroup_yellow">
                 <Link to={{pathname: '/singleOrder', search: location?.search}} type="button" className="btnFill" id="singleOrder">
                   <span>{t("about.t9")}</span>
                   <Add/>
                 </Link>
               </div>
             </div>
           </div>
         </div>
       </div>
     </>
  )
}
